module.exports = "<div seedelement>\n  <div class=\"lui-select__dialog lui-select__dialogplaceholder lui-interactive\">\n    <div class=\"lui-select__dialogwrapper\"></div>\n    <slot name=\"chevronclosed\"></slot>\n    <slot name=\"chevronopened\"></slot>\n  </div>\n  <div>\n    <slot name=\"menu\"></slot>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-select/theme/lui-select.html
// module id = 305
// module chunks = 0 1 14